import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout.js';
import LangGate from './components/LangGate.js';
import LanguageSync from './components/LanguageSync.js';
import AnalyticsTracker from './components/AnalyticsTracker.js';
import CookieConsentBanner from './components/CookieConsentBanner.js';
import NotFound from './pages/NotFound.js';
import { routeConfig } from './routes.js';
import './App.css';
import '@aws-amplify/ui-react/styles.css';
import './i18n.js'; // Initialize i18n

function App() {
  return (
    <HelmetProvider>
      <Authenticator.Provider>
        <Router>
          <LanguageSync />
          <AnalyticsTracker />
          <CookieConsentBanner />
          <Layout>
          <Routes>
            {/* Default language (English): no URL prefix */}
            {routeConfig.map(({ path, element }) => (
              <Route key={`bare:${path}`} path={path} element={element} />
            ))}

            {/* Other languages: /:lang prefix, e.g. /es/dashboard */}
            <Route path="/:lang" element={<LangGate />}>
              {routeConfig.map(({ path, element }) => (
                <Route
                  key={`i18n:${path}`}
                  {...(path === '/' ? { index: true } : { path: path.slice(1) })}
                  element={element}
                />
              ))}
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </Router>
    </Authenticator.Provider>
    </HelmetProvider>
  );
}

export default App;